<template>
    <vue-editor
        v-model="content"
        :editor-toolbar="customToolbar"
        v-bind="{ placeholder }"
        @input="onInput"
    ></vue-editor>
</template>

<style lang="less" type="text/less">
.FormItem{
    .ql-container{
        height: auto;
        .ql-editor{
            height: auto;
        }
    }
}
</style>
<script type="text/babel">
import { VueEditor } from 'vue2-editor'

export default {
    components: {
        VueEditor,
    },
    props: ['value', 'editorToolbar', 'placeholder'],

    data() {
        return {
            content: this.value,
            customToolbar: this.editorToolbar || [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }]
            ]
        }
    },
    methods: {
        onInput(event) {
            this.$emit('input', event)
        },
    },
}
</script>
